import { Navigate, Route, Routes } from 'react-router-dom';
import { Layout } from './components/Layout';
import { Login } from './pages/Login';
import { Invoices } from './pages/Invoices';
import { InvoiceEditor } from './pages/InvoiceEditor';
import { Quotations } from './pages/Quotations';
import { QuotationEditor } from './pages/QuotationEditor';
import { Clients } from './pages/Clients';
import { Products } from './pages/Products';
import { Users } from './pages/Users';
import { Settings } from './pages/Settings';
import { Security } from './pages/Security';
import { Purchases } from './pages/Purchases';
import { Accounting } from './pages/Accounting';
import { Reports } from './pages/Reports';
import { Backups } from './pages/Backups';
import { Verifactu } from './pages/Verifactu';
import { useSession } from './lib/session';
import { useT } from './lib/i18n';

export function App() {
  const { status } = useSession();
  const t = useT();

  if (status === 'loading') {
    return (
      <div className="login">
        <div className="loading-row"><span className="spinner" />{t('common.loading')}</div>
      </div>
    );
  }

  if (status === 'anonymous') return <Login />;

  return (
    <Routes>
      <Route element={<Layout />}>
        <Route index element={<Navigate to="/invoices" replace />} />
        <Route path="invoices" element={<Invoices />} />
        {/* "new" and a numeric id share the editor. */}
        <Route path="invoices/:id" element={<InvoiceEditor />} />
        <Route path="quotations" element={<Quotations />} />
        {/* "new" and a numeric id share the editor. */}
        <Route path="quotations/:id" element={<QuotationEditor />} />
        <Route path="purchases" element={<Purchases />} />
        <Route path="clients" element={<Clients />} />
        <Route path="products" element={<Products />} />
        <Route path="users" element={<Users />} />
        <Route path="reports" element={<Reports />} />
        <Route path="accounting" element={<Accounting />} />
        <Route path="settings" element={<Settings />} />
        <Route path="backups" element={<Backups />} />
        <Route path="verifactu" element={<Verifactu />} />
        <Route path="security" element={<Security />} />
        <Route path="*" element={<Navigate to="/invoices" replace />} />
      </Route>
    </Routes>
  );
}
